import React, { Component } from "react"
import { StyleProvider } from "../contexts/StyleContext"
import "./Main.scss"
import Header from "../components/Header/Header"
import About from "../components/About/About"
import Skills from "../components/Skills/Skills"
import Projects from "../components/Projects/Projects"
import Experience from "../components/Experience/Experience"
import Education from "../components/Education/Education"
import Awards from "../components/Awards/Awards"
import FeaturedWork from "../components/FeaturedWork/FeaturedWork"
import Contact from "../components/Contact/Contact"
import Footer from "../components/Footer/Footer"
import Scroll from "../components/ScrollToTop/Scroll"
import VolExp from "../components/Experience/VolExp"


export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDark: false
    };
  }

  componentDidMount() {
    // Check localStorage first, then system preference
    let isDark = false;
    const storedTheme = localStorage.getItem("isDark");
    
    if (storedTheme !== null) {
      isDark = JSON.parse(storedTheme);
    } else {
      // Check system preference
      const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
      isDark = darkPref.matches;
      localStorage.setItem("isDark", isDark);
    }
    
    this.setState({ isDark }, () => {
      this.applyTheme(isDark);
    });

    // Listen for system theme changes
    const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
    this.darkModeQuery = darkPref;
    this.darkModeQuery.addEventListener('change', this.handleSystemThemeChange);
  }

  componentWillUnmount() {
    if (this.darkModeQuery) {
      this.darkModeQuery.removeEventListener('change', this.handleSystemThemeChange);
    }
  }

  handleSystemThemeChange = (e) => {
    // Only update if user hasn't manually set a preference
    // Once user manually changes theme, we stop following system preference
    // This prevents unwanted theme changes after user has made a choice
    const storedTheme = localStorage.getItem("isDark");
    // If there's no stored preference, follow system changes
    if (storedTheme === null) {
      const isDark = e.matches;
      this.setState({ isDark }, () => {
        localStorage.setItem("isDark", isDark);
        this.applyTheme(isDark);
      });
    }
    // If there's a stored preference, ignore system changes (user has made a choice)
  }

  applyTheme = (isDark) => {
    // Apply theme class to body for global styles
    if (isDark) {
      document.body.classList.add('dark-mode');
      document.documentElement.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
      document.documentElement.classList.remove('dark-mode');
    }
  }

  changeTheme = () => {
    const newIsDark = !this.state.isDark;
    this.setState({ isDark: newIsDark }, () => {
      localStorage.setItem("isDark", newIsDark);
      this.applyTheme(newIsDark);
    });
  };

  render() {
    return (
      <div className={this.state.isDark ? "dark-mode" : "light-mode"}>
        <StyleProvider
          value={{ isDark: this.state.isDark, changeTheme: this.changeTheme }}>
          <Header />
          <About />
          <Skills />
          <Education />
          <Experience />
          <VolExp />
          <Projects />
          <Awards />
          <FeaturedWork />
          <Contact />
          <Footer />
          <Scroll showBelow={400} />
        </StyleProvider>
      </div>
    );
  }
}
